/* eslint-disable */
/* tslint:disable */

/** updateSpecialties
 * method: put
 * summary: Update Hublo Pool application specialties
 */

import type {
  UpdateSpecialtiesHubloPoolApplicationBodyDto,
  GeneralOkNotOkResultDto,
  BadRequestResponseDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/bff-worker/pool/application/specialties`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/pool/application/specialties`

export type RequestBody = UpdateSpecialtiesHubloPoolApplicationBodyDto

export type UpdateSpecialtiesSuccess = GeneralOkNotOkResultDto
export type UpdateSpecialtiesError = BadRequestResponseDto | ApiResponseDto
